export default {
  s1: `Damit wir Ihnen das bestmögliche Suchergebnis zur Verfügung stellen können, wählen Sie bitte aus, für welchen Zweck Sie Datensätze benötigen. `,
  s2col1: `Dabei bedeuten: <br>1: Anschaffung der Behandlungseinheiten vor >20 Jahren; kein digitales Röntgen<br>
                      3: Anschaffung der Behandlungseinheiten vor ca. 10 Jahren; teildigitalisierte Prozesse<br>
                      5: Anschaffung der Behandlungseinheiten vor <2 Jahren;<br>
                      vollständig digitalisierte Praxis.`,
  s2col2: `Dabei bedeuten: <br>1: Anschaffung Praxiseinrichtung vor >30 Jahren, deutlich sichtbare Mängel im Mobiliar,<br>
                      3: Anschaffung Praxiseinrichtung vor >10 Jahren, modernes Mobiliar,<br>
                      5: Anschaffung Praxiseinrichtung vor <5 Jahren, modernes/ hochwertiges Mobiliar mit keinen/kaum Gebrauchsspuren<br>`,
  s2col3: `Geringer Aufwand = niederige Investitionskosten bzw. hoher Aufwand = hohe Investitionskosten`,
  s3: `Nehmen Sie hier regionale Eingrenzungen vor, um das Potential Ihrer Wunschregion sehen zu können. Hier ist eine Mehrfachauswahl möglich.`,
  s3Col1: `Zusätzlich haben Sie die Möglichkeit Standorte einzugrenzen, die aktiv im Betrieb, aktuell in Bau oder in Planung sind oder deren Gründungsdatum im letzten Monat liegt. Hier ist eine Mehrfachauswahl möglich.`,
  s4: `Um Streuverluste zu minimieren, können Sie hier weitere Eingrenzungen wie Spezialisierungen oder Betriebsgröße vornehmen. Hier ist eine Mehrfachauswahl möglich.`,
};



// WEBPACK FOOTER //
// ./src/strings/tooltip-data.js